import _ from 'lodash'
import { Reducer } from 'redux'
import { getType } from 'typesafe-actions'

import { Dictionary } from '../../utils/types'

import { GtmActions } from './actions'
import { GtmState } from './types'

const MS_PER_DAY = 1000 * 60 * 60 * 24

function dateDiffInDays(a: Date, b: Date) {
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate())
  return Math.floor((utc2 - utc1) / MS_PER_DAY)
}

const initialState: GtmState = {
  purchases: {}
}

export const gtmReducer: Reducer<GtmState, GtmActions> = (state = initialState, action) => {
  switch (action.type) {
    case getType(GtmActions.setOrderTracked): {
      const { orderId } = action.payload
      const now = new Date()

      const purchases = {
        ...state.purchases,
        [orderId]: now
      }

      return {
        purchases: _.reduce(
          purchases,
          (acc, date, key) => {
            if (dateDiffInDays(date, now) > 7) {
              return _.omit(purchases, [key])
            }
            return acc
          },
          {} as Dictionary<Date>
        )
      }
    }
    default:
      return state
  }
}
